export default "__VITE_ASSET__RvmpxVH1__"